import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || "http://localhost:8080";
const MCP_HEADER = { "X-MCP-Protocol": "1.0" };

const initialForm = {
  name: "",
  document: "",
  email: "",
  phone: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  bankAccount: "",
  bankAgency: "",
  bankName: "",
};

export default function Landlords({ keycloak }) {
  const [landlords, setLandlords] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${keycloak.token}`,
    ...MCP_HEADER,
  };

  const loadLandlords = async () => {
    const response = await fetch(`${API_URL}/api/landlords`, { headers });
    const data = await response.json();
    setLandlords(data || []);
  };

  useEffect(() => {
    loadLandlords().catch((error) => console.error("Erro ao carregar locadores", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createLandlord = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/landlords`, {
        method: "POST",
        headers,
        body: JSON.stringify(form),
      });
      const created = await response.json();
      setLandlords((prev) => [created, ...prev]);
      setForm(initialForm);
    } catch (error) {
      console.error("Erro ao criar locador", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <section className="hero">
        <h1>Cadastro de Locadores</h1>
        <p>Gerencie os proprietários de imóveis cadastrados no sistema.</p>
      </section>

      <section className="panel">
        <h2 className="section-title">Novo Locador</h2>
        <div className="grid grid-3">
          <input
            placeholder="Nome completo"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <input
            placeholder="CPF/CNPJ"
            value={form.document}
            onChange={(e) => setForm({ ...form, document: e.target.value })}
          />
          <input
            type="email"
            placeholder="E-mail"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            placeholder="Telefone"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
          <input
            placeholder="Endereço"
            value={form.address}
            onChange={(e) => setForm({ ...form, address: e.target.value })}
          />
          <input
            placeholder="Cidade"
            value={form.city}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
          />
          <input
            placeholder="Estado"
            value={form.state}
            onChange={(e) => setForm({ ...form, state: e.target.value })}
          />
          <input
            placeholder="CEP"
            value={form.zipCode}
            onChange={(e) => setForm({ ...form, zipCode: e.target.value })}
          />
          <input
            placeholder="Banco"
            value={form.bankName}
            onChange={(e) => setForm({ ...form, bankName: e.target.value })}
          />
          <input
            placeholder="Agência"
            value={form.bankAgency}
            onChange={(e) => setForm({ ...form, bankAgency: e.target.value })}
          />
          <input
            placeholder="Conta bancária"
            value={form.bankAccount}
            onChange={(e) => setForm({ ...form, bankAccount: e.target.value })}
          />
        </div>
        <button className="btn-primary" type="button" onClick={createLandlord} disabled={loading}>
          {loading ? "Salvando..." : "Cadastrar Locador"}
        </button>
      </section>

      <section>
        <h2 className="section-title">Locadores Cadastrados</h2>
        <div className="grid grid-3">
          {landlords.map((landlord) => (
            <div key={landlord.id} className="listing-card">
              <h4>{landlord.name}</h4>
              <div>Documento: {landlord.document}</div>
              <div>E-mail: {landlord.email}</div>
              <div>Telefone: {landlord.phone}</div>
              <div>{landlord.city}, {landlord.state}</div>
              {landlord.bankName && <div>Banco: {landlord.bankName}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
